import axios from "axios";

import { getAuthHeader } from "../headers";

// ===================================================================================
//	SECTOR SUGGESTIONS
// ===================================================================================
export const sectorSuggestionInProcess = () => {
	return {
		type: "SECTOR_SUGGESTION_IN_PROGRESS"
	};
};

export const sectorSuggestionHasError = err => {
	return {
		type: "SECTOR_SUGGESTION_HAS_ERROR",
		error: err
	};
};

export const sectorSuggestionSuccess = data => {
	return {
		type: "SECTOR_SUGGESTION_SUCCESS",
		data
	};
};

export function getSectorSuggestions(term) {
	return (dispatch, getState) => {
		dispatch(sectorSuggestionInProcess());

		const params = { q: term };

		// Add id of record to find if passed
		const endPoint = "sectors/suggestions";

		return axios
			.get(process.env.REACT_APP_API_URL + endPoint, {
				headers: getAuthHeader(getState().user),
				params
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					if (response.data.message !== "") {
						dispatch(sectorSuggestionHasError(response.data.message));
					} else {
						dispatch(sectorSuggestionHasError(response.data.errors));
					}
				} else {
					return dispatch(sectorSuggestionSuccess(response));
				}
			})
			.catch(err => {
				dispatch(sectorSuggestionHasError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/sectorSuggestions.js